<div>
  <div class="modal-header rb-modal-header">
    <h4 class="modal-title font-weight-bold text-black-1">{{ title }}</h4>
  </div>
  <div class="modal-body">
    <p>{{ message }}</p>
  </div>
  <div class="modal-footer border-0 rb-modal-footer">
    <button class="btn-cancel ml-4 w-100" (click)="activeModal.close(false)">Cancel</button>
    <button class="btn-save ml-4 w-100" (click)="activeModal.close(true)">Submit</button>
  </div>
</div>
